import { Injectable, inject } from '@angular/core';
import { SbModalService } from '../sb-modal/sb-modal.service';

const escapeHtml = (text: string): string => text.replace(/[&<>"']/g, (character) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;'
}[character] as string));

/** The popup a paid feature opens for someone whose account does not have it. */
@Injectable({ providedIn: 'root' })
export class SbPremiumService {
  private readonly modal = inject(SbModalService);

  explain(feature: string): void {
    this.modal.open({
      title: 'Premium feature',
      body: `<strong>${escapeHtml(feature)}</strong> is a paid feature. `
        + 'Contact your Snöball account manager to enable it for your account.',
      size: 'md',
      showFooter: true,
      buttons: [{ id: 'ok', label: 'OK', style: 'primary', closeValue: true }],
    }).result.catch(() => undefined);
  }
}
